import * as React from 'react';
import { useEffect, useState } from 'react';

interface TaxIdInputProps {
    value?: string;
    onChange: (value?: string) => void;
}

const STRIPE_TAX_ID_INPUT = 'stripe-tax-id-input';

export const StripeTaxIdInput: React.FC<TaxIdInputProps> = ({ value = '', onChange }) => {
    const [taxCode, setTaxCode] = useState(value);

    useEffect(() => {
        setTaxCode(value);
        onChange(value);
    },        [ value ]);

    return (
        <div className="stripe-custom-field stripe-custom-field--tax">
            <label htmlFor={STRIPE_TAX_ID_INPUT}>
                Tax ID (optional)
            </label>
            <div>
                <input
                    id={STRIPE_TAX_ID_INPUT}
                    type="text"
                    value={taxCode}
                    onChange={(e) => {
                        onChange(e.target.value);
                        setTaxCode(e.target.value);
                    }}
                />
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/webportal/components/billing/details/stripe/StripeTaxIdInput.tsx